module.exports = __webpack_public_path__ + "static/media/Outside Dining 1.54ba2054.jpg";